<template>
  <div>
    <div class="card" :class="$style.container">
      <div class="text-dark font-size-24 mb-4">
        <strong>Reset Password</strong>
      </div>
      <div v-if="linkValid">
        <a-form class="mb-4" :form="form" @submit="handleSubmit">
          <a-form-item>
            <a-input
              size="large"
              placeholder="Password"
              type="password"
              v-decorator="['password', {initialValue: '', rules: [{ required: true, message: 'Please input your Password!' }]}]"
            />
          </a-form-item>
          <a-form-item>
            <a-input
              size="large"
              placeholder="Confirm Password"
              type="password"
              v-decorator="['confirmpassword', {initialValue: '', rules: [{ required: true, message: 'Please input your Password!' }]}]"
            />
          </a-form-item>
          <div v-if="authorized">
            <a-alert
              :message="msgAlert.message"
              :description="msgAlert.description"
              type="success"
              show-icon
            />
          </div>
          <div v-else>
            <a-button
              htmlType="submit"
              size="large"
              type="primary"
              class="text-center w-100"
              :loading="loading"
            >
              <strong>Reset my password</strong>
            </a-button>
          </div>
        </a-form>
      </div>
      <div v-else>
        <a-alert
          :message="msgAlert.message"
          :description="msgAlert.description"
          type="error"
          show-icon
        />
      </div>
      <div v-if="authorized">
        <router-link to="/dashboard" class="kit__utils__link font-size-16">
          <i class="fe fe-arrow-left mr-1 align-middle" />
          Go to Admin Page
        </router-link>
      </div>
      <div v-else>
        <router-link to="/auth/login" class="kit__utils__link font-size-16">
          <i class="fe fe-arrow-left mr-1 align-middle" />
          Go to Sign in
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import * as service from '@/services/users'
export default {
  name: 'CuiResetPassword',
  computed: {
    ...mapState(['settings']),
    ...mapGetters({ authorized: 'user/authorized' }),
    loading() {
      return this.$store.state.loading
    },
    /*    linkvalid() {
      return this.$store.state.user.confirmpass.link
    },  */
  },
  data() {
    return {
      hasId: this.$route.params.hasId,
      tokenId: this.$route.params.token,
      form: this.$form.createForm(this),
      msgAlert: {
        message: '',
        description: '',
      },
      linkValid: true,
    }
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$store.dispatch('user/RESETPASSWRD', { payload: values })
            .then(({ success, message }) => {
              if (success) {
                this.msgAlert = {
                  message: this.$t('authForm.tankYou'),
                  description: this.$t('authForm.resetpassSuccess'),
                }
              } else {
                this.$notification.error({
                  message: this.$t('authForm.loginFailed'),
                  description: message,
                })
              }
            })
        }
      })
    },
  },
  created() {
    service.resetpassconf(this.hasId, this.tokenId).then(response => {
      if (!(response.success)) {
        switch (response.code) {
          case 404:
            this.msgAlert.description = this.$t('authForm.emailNotFound')
            break
          case 422:
            this.msgAlert.description = 'Missing storeId attribute!'
            break
          default:
            this.msgAlert.description = this.$t('authForm.systemBusy')
        }
        this.msgAlert.message = this.$t('authForm.forgotpassFailed')
        this.linkValid = false
      }
    })
  },
  watch: {
    loginStatusCode(newValue, oldValue) {
      if (newValue !== 0) {
        if (newValue === 422) {
          this.form.setFieldsValue({ confirmpassword: '' })
        }
        this.$store.commit('user/CLEAR_LOGIN')
      }
    },
  },
}
</script>
<style lang="scss" module>
@import "@/components/cleanui/system/Auth/style.module.scss";
</style>
